import { Listing } from '@/types/listing';

interface Props {
  listing: Listing;
  onEdit: (listing: Listing) => void;
  onDelete: (id: string) => void;
}

export default function AdminListingRow({ listing, onEdit, onDelete }: Props) {
  return (
    <div className="flex items-center gap-4 p-4 bg-white rounded-lg border border-gray-100 hover:border-amber-200 transition-colors group">
      {/* Thumbnail */}
      <div className="w-20 h-16 rounded-md overflow-hidden flex-shrink-0 bg-gray-100">
        {listing.images?.[0] ? (
          <img src={listing.images[0]} alt={listing.address} className="w-full h-full object-cover object-top" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <i className="ri-home-3-line text-gray-300 text-2xl"></i>
          </div>
        )}
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-900 truncate">{listing.address}</p>
        <div className="flex items-center gap-3 mt-1">
          <span className="text-amber-600 font-bold text-sm">{listing.price}</span>
          <span className="text-gray-400 text-xs">{listing.beds}bd · {listing.baths}ba · {listing.sqft} sqft</span>
        </div>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-gray-500">{listing.type}</span>
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            listing.status === 'Active' ? 'bg-green-100 text-green-700' :
            listing.status === 'New' ? 'bg-amber-100 text-amber-700' :
            listing.status === 'Pending' ? 'bg-orange-100 text-orange-700' :
            'bg-gray-100 text-gray-600'
          }`}>
            {listing.status}
          </span>
        </div>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-2 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
        <button
          onClick={() => onEdit(listing)}
          className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-amber-50 text-amber-600 cursor-pointer transition-colors"
          title="Edit"
        >
          <i className="ri-edit-line text-sm"></i>
        </button>
        <button
          onClick={() => onDelete(listing.id)}
          className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-red-50 text-red-400 cursor-pointer transition-colors"
          title="Delete"
        >
          <i className="ri-delete-bin-line text-sm"></i>
        </button>
      </div>
    </div>
  );
}
